import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { ToastContainer } from "react-toastify";
import CustomAutoComplete from "../../../shared/autoCompletes/CustomAutoComplete";
import CustomLoadingButton from "../../../shared/button/CustomLoadingButton";
import { FormatMoney } from "../../../shared/format/Formats";
import CustomTextField from "../../../shared/textFields/CustomTextField";
import FormatedCustomTextField from "../../../shared/textFields/FormatedCustomTextField";
import usePowerDistributionCompanyForm from "../controller";
import useCreatePowerDistributionCompany from "./controller";

export default function CreatePowerDistributionCompany({ onPowerCompanyCreated, layout = "horizontal" }) {
  const formController = usePowerDistributionCompanyForm();
  const controller = useCreatePowerDistributionCompany(formController, onPowerCompanyCreated);

  const isVertical = layout === "vertical";
  const buttonStyle = {
    alignSelf: "flex-end",
    mt: isVertical ? 2 : 5,
    width: isVertical ? "30%" : "20%",
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        height: "auto",
        minHeight: isVertical ? "auto" : 300,
      }}
    >
      <ToastContainer />

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          p: 2,
          justifyContent: "space-between",
          borderRadius: 3,
          height: "100%",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: isVertical ? "column" : "row",
            justifyContent: "space-between",
            gap: isVertical ? 2 : 0,
          }}
        >
          <Box
            sx={{
              width: isVertical ? "100%" : "45%",
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <CustomTextField
              params={formController.powerDistributionCompanyName}
              disabled={controller.isDisabled}
              label="Nome da Concessionária"
              errorLabel="Nome Incorreto"
              maxLength={30}
            />
            <CustomAutoComplete
              params={formController.state}
              options={formController.apiStates}
              disabled={controller.isDisabled}
              label="Estado"
              width="100%"
            />
            <CustomAutoComplete
              params={formController.engineer}
              options={formController.apiEngineers}
              disabled={controller.isDisabled}
              label="Engenheiro Padrão"
              width="100%"
            />
          </Box>
          <Box
            sx={{
              width: isVertical ? "100%" : "45%",
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <FormControlLabel
              control={<Checkbox checked={formController.hasProcessing.checked} onChange={formController.hasProcessing.onChange} />}
              label="Possui processamento?"
              labelPlacement="start"
            />
            <Box display="flex" sx={{ justifyContent: "space-between" }}>
              <FormControlLabel
                control={<Checkbox checked={formController.hasADifferentPrice.checked} onChange={formController.hasADifferentPrice.onChange} />}
                label="Outro Valor de ART?"
                labelPlacement="start"
              />
              <FormatedCustomTextField
                params={formController.price}
                disabled={!formController.hasADifferentPrice.checked}
                label="Valor"
                errorLabel="Valor Incorreto"
                inputcomponent={FormatMoney}
                required={false}
                width="45%"
              />
            </Box>
          </Box>
        </Box>

        <CustomLoadingButton
          buttonText="Cadastrar"
          buttonLoadingText="Cadastrando..."
          sx={buttonStyle}
          disabled={controller.requestLoading}
          handleButtonClick={controller.handleClick}
          requestLoading={controller.requestLoading}
        />
      </Box>
    </Box>
  );
}
